export default __webpack_public_path__ + "static/media/bean-type.9cf8202e.webp";